import Modifier from "../Modifier";
import DatePeriod from "../DatePeriod";

class ExtrapolateConstantModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'extrapolate_constant';
        this.steps = parameters.steps;
    }

    compute(data, periodicity) {

        // get latest value
        const value = data[data.length - 1].value;
        const begin = data[data.length - 1].time;

        // get dates!
        const dates = DatePeriod.grow(begin, periodicity, this.steps);

        _.forEach(dates, function (date) {
            data.push({
                time: date,
                value: value,
            });
        });

        return data;
    }
}

export default ExtrapolateConstantModifier;
